import { defineComponent as _defineComponent } from 'vue'
import { AmountType, Trade, getCcyByAmountType } from 'ah-api-gateways';
import { computed } from 'vue';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import TradesFormattedCurrency from '../../currency/TradesFormattedCurrency.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeNotionalValueCell',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: Trade;
};



const buyCCY = computed(() => getCcyByAmountType(props.item, AmountType.BUY));

const sellCCY = computed(() => getCcyByAmountType(props.item, AmountType.SELL));

return { __sfc: true,props, buyCCY, sellCCY, TradesFormattedCurrency }
}

})